// NPM
import React from "react";

// State
import { useSelector } from "react-redux";

// Components
import RoundedRect from "components/shared/RoundedRect";

function SeatShareGraphRowValue(props) {
  // State
  const responsiveView = useSelector((state) => state.responsiveView.value);

  const { seatShareDatum, xDomain, rowY, rowHeight, party } = props;

  let radius;
  let minValueDiffsInPixelsPerCharacter;
  let centreLabelSize;
  let confidenceLabelSize;
  let labelOffset;
  let fontWeight;

  switch (responsiveView) {
    // case "mobile":
    //   radius = 12;
    //   minValueDiffsInPixelsPerCharacter = 5;
    //   centreLabelSize = 9;
    //   confidenceLabelSize = 8;
    //   labelOffset = 5;
    //   break;

    case "teeny":
    case "mobile":
    case "tablet":
      minValueDiffsInPixelsPerCharacter = 10;
      radius = 20;
      centreLabelSize = 14;
      confidenceLabelSize = 12;
      labelOffset = 7;
      break;

    case "desktop":
      minValueDiffsInPixelsPerCharacter = 10;
      radius = 26;
      centreLabelSize = 18;
      confidenceLabelSize = 14;
      labelOffset = 7;
      fontWeight = "bold";
      break;
  }

  // Get the X position based on the seat value in our x-domain
  const xPos = xDomain(seatShareDatum.median);

  // Y Position is the center for the row based on height
  const yPos = rowHeight / 2;

  // Get the row's chart data
  const lower = parseInt(seatShareDatum.lower);
  const median = parseInt(seatShareDatum.median);
  const upper = parseInt(seatShareDatum.upper);

  // Add a minimum value so the bar can always fit the number of digits in the label
  // This means the bar will not actually represent the length of the chart data

  function getLowerValue(lowerValue) {
    const lowerLabelLength = lower.toString().length;
    const lowerWidth = xPos - radius - xDomain(lowerValue);
    const requiredWidth =
      minValueDiffsInPixelsPerCharacter * lowerLabelLength + labelOffset;

    if (lowerWidth < requiredWidth) {
      return getLowerValue(lowerValue - 0.5);
    } else {
      return lowerValue;
    }
  }

  function getUpperValue(upperValue) {
    const upperLabelLength = upper.toString().length;
    const upperWidth = xDomain(upperValue) - (xPos + radius);
    const requiredWidth =
      minValueDiffsInPixelsPerCharacter * upperLabelLength + labelOffset;

    if (upperWidth < requiredWidth) {
      return getUpperValue(upperValue + 0.5);
    } else {
      return upperValue;
    }
  }

  const lowerValue = getLowerValue(lower);
  const upperValue = getUpperValue(upper);
  const endVal =
    props.majoritySeatNum && seatShareDatum.upper < props.majoritySeatNum
      ? props.majoritySeatNum
      : props.totalSeatNum;

  return (
    <g className="SeatShareGraphRowValue">
      {seatShareDatum.lower &&
        seatShareDatum.lower !== seatShareDatum.median && (
          <g>
            {/* Draw the confidence interval bar */}
            <RoundedRect
              x={xDomain(lowerValue)}
              y={yPos - radius / 2}
              width={xPos - radius - xDomain(lowerValue) + 3}
              height={radius}
              radius={radius / 2}
              fill={party.color}
              blRounded
              tlRounded
            />

            {/* Add the value label */}
            <text
              x={xDomain(lowerValue) + labelOffset}
              y={yPos}
              textAnchor="start"
              dominantBaseline="central"
              fontWeight={fontWeight}
              fontSize={confidenceLabelSize}
              fill="white"
            >
              {seatShareDatum.lower}
            </text>
          </g>
        )}

      {seatShareDatum.upper && upper > median && (
        <g>
          {/* Draw the confidence interval bar */}
          <RoundedRect
            x={xPos + radius - 3}
            y={yPos - radius / 2}
            width={xDomain(upperValue) - (xPos + radius) + 3}
            height={radius}
            radius={radius / 2}
            fill={party.color}
            trRounded
            brRounded
          />

          {/* Add the value label */}
          <text
            x={xDomain(upperValue) - labelOffset}
            y={yPos}
            textAnchor="end"
            dominantBaseline="central"
            fontWeight={fontWeight}
            fontSize={confidenceLabelSize}
            fill="white"
          >
            {seatShareDatum.upper}
          </text>
        </g>
      )}

      {/* Draw the centre circle */}
      <circle
        cx={xPos}
        cy={yPos}
        r={radius}
        fill="white"
        stroke={party.color}
        strokeWidth="2"
      />

      {/* Add the centre label */}
      <text
        x={xPos}
        y={yPos}
        textAnchor="middle"
        dominantBaseline="central"
        fontWeight={fontWeight}
        fontSize={centreLabelSize}
      >
        {seatShareDatum.median}
      </text>
    </g>
  );
}

export default SeatShareGraphRowValue;
